import { useLocalizedString } from '@volvo-cars/react-locale-provider';
import { label as pauseLabelTranslations } from '../../i18n/pause/i18n';
import { label as playLabelTranslations } from '../../i18n/play/i18n';
import { IconButton, type LocalizedIconButtonProps } from '../icon-button';

export type PlayPauseIconButtonProps = LocalizedIconButtonProps & {
  paused: boolean;
};

/**
 * A localized icon button that toggles between play and pause states.
 * Uses the useLocale hook from LocaleProvider context to provide an accessible label
 * based on the current locale, or wraps with one if `locale` is provided.
 */
export const PlayPauseIconButton = ({
  paused,
  ...props
}: PlayPauseIconButtonProps) => {
  const playLabel = useLocalizedString(playLabelTranslations);
  const pauseLabel = useLocalizedString(pauseLabelTranslations);

  return (
    <IconButton
      icon={paused ? 'pause' : 'play'}
      aria-label={paused ? pauseLabel : playLabel}
      {...props}
    />
  );
};
